import { useEffect } from 'react';
import Logotype from '@/components/shared/Logotype';

export default function Xent() {
  useEffect(() => {
    document.title = 'xeNT';
  }, []);

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      minHeight: 'calc(100vh - 64px)',
      padding: 32,
    }}>
      <img
        src="/logo-xent.png"
        alt="xeNT"
        style={{
          maxWidth: '60%',
          maxHeight: '60vh',
          objectFit: 'contain',
          clipPath: 'url(#squircle)',
        }}
      />
    </div>
  );
}
